<template>
  <div>
    <el-form label-position="left" label-width="100px" :model="blacklistedOriginator">
      <el-form-item label="Originator">
        <el-input v-model="blacklistedOriginator.originator" placeholder="Originator"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer clearfix">
      <span class="pull-right">
        <el-button id="cancel" type="danger" @click="cancel" plain>Cancel</el-button>
        <el-button id="save" type="primary" :loading="saving" @click="blacklistOriginator" plain>Save</el-button>
      </span>
    </span>
  </div>
</template>

<script>
import SocialIcon from '@/components/common/Icons/SocialIcon';

export default {
  name: 'BlacklistOriginatorEdit',
  components: { SocialIcon },
  props: ['originator'],
  data: () => ({
    savingTimeslot: false,
    blacklistedOriginator: {
      originator: '',
    },
  }),
  computed: {
    saving() {
      return (
        this.$store.state.blacklist.creatingBlacklistOriginator ||
        this.$store.state.blacklist.updatingBlacklistOriginator
      );
    },
  },
  mounted() {
    this.blacklistedOriginator = this.originator;
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    blacklistOriginator() {
      this.$emit('save', this.blacklistedOriginator);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-select {
  max-width: 100% !important;
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// BlacklistOriginatorEdit.vue?2bc26570